// extracted by mini-css-extract-plugin
var _1 = "TaskTypeListMoreItem-moduleTaskTypeListMoreItem__oi9_s MultiValuedListMoreItem-moduleMultiValuedListMoreItem__SSTEE";
var _2 = "TaskTypeListMoreItem-modulelistItem__HStL7 TextListItem-moduleTextListItem__KEr4C";
export { _1 as "TaskTypeListMoreItem", _2 as "listItem" }
